import React from 'react';
import { useSelector } from 'react-redux';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import type { LinkCarouselItemClickPayload } from '@noths/polaris-client-ribbons-design-system';
import { LinkCarousel } from '@noths/polaris-client-ribbons-design-system';

import { selectRelatedCategories } from 'src/components/organisms/LinkCarousel/modules/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { RELATED_CATEGORIES_TITLE } from '../constants/copy';
import * as styles from '../styles/LinkCarousel.styles';

const trackLinkCarouselVisible = () => {
  sendGAEvent({
    event: 'custom_event',
    event_category: 'Related Category',
    event_action: 'Impression',
    event_label: 'not set',
  });
};

export const LinkCarouselContainer = () => {
  const items = useSelector((state: ReduxApplicationState) =>
    selectRelatedCategories(state).map((relatedCategory) => {
      return {
        href: relatedCategory.rel!,
        text: relatedCategory.title!,
      };
    }),
  );

  const onItemClick = (
    evt: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
    { index }: LinkCarouselItemClickPayload,
  ) => {
    sendGALinkClickEvent(evt, {
      event: 'custom_event',
      event_category: 'Related Category',
      event_action: 'Link Click',
      event_label: items[index].text,
    });
  };

  return items.length > 0 ? (
    <div css={styles.linkCarouselWrapper}>
      <LinkCarousel
        items={items}
        onItemClick={onItemClick}
        onVisible={trackLinkCarouselVisible}
        title={RELATED_CATEGORIES_TITLE}
      />
    </div>
  ) : null;
};
